import { render, staticRenderFns } from "./Chimney.vue?vue&type=template&id=20dfafb2&scoped=true"
import script from "./Chimney.vue?vue&type=script&lang=ts"
export * from "./Chimney.vue?vue&type=script&lang=ts"
import style0 from "./Chimney.vue?vue&type=style&index=0&id=20dfafb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfafb2",
  null
  
)

export default component.exports